<div class="network-check-offline-modal">
  <h3>{{ 'INTERNET_CONNECTION_ISSUE' | translate }}</h3>
  <div class="network-check-offline-modal-body">
    <p>
      {{ 'NO_ACCESS_TO_PLATFORM' | translate }}
    </p>
    <p>{{ 'CHECK_CONNECTION' | translate }}</p>
    <p>{{ 'CONTACT_SUPPORT' | translate }}</p>
  </div>
  <div class="network-check-offline-modal-footer">
    <div class="network-check-offline-modal-footer-link">
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <mask
          id="mask0_4836_21565"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="21">
          <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4836_21565)">
          <path
            d="M16.2003 17.5846C14.6298 17.5846 13.052 17.2195 11.4671 16.4892C9.88218 15.759 8.426 14.7288 7.09855 13.3987C5.77109 12.0686 4.74225 10.6124 4.01201 9.03014C3.28177 7.44787 2.91666 5.87149 2.91666 4.30099C2.91666 4.0487 2.99999 3.83846 3.16666 3.67026C3.33332 3.50207 3.54166 3.41797 3.79166 3.41797H6.50957C6.72005 3.41797 6.90568 3.48661 7.06647 3.62391C7.22726 3.7612 7.32955 3.9308 7.37334 4.13272L7.85091 6.58462C7.88403 6.81218 7.87709 7.0077 7.83007 7.17116C7.78307 7.33461 7.69867 7.4719 7.57687 7.58301L5.6522 9.45641C5.96203 10.0237 6.31593 10.5603 6.71391 11.0662C7.11188 11.5721 7.5427 12.0552 8.00637 12.5157C8.46364 12.973 8.94976 13.3977 9.46472 13.7898C9.97968 14.1819 10.5358 14.5467 11.133 14.8843L13.0032 12.9981C13.1335 12.8624 13.2914 12.7673 13.4767 12.7128C13.6621 12.6584 13.8547 12.645 14.0545 12.6728L16.3685 13.1439C16.579 13.1995 16.7507 13.3069 16.8838 13.466C17.0168 13.6252 17.0833 13.8058 17.0833 14.0077V16.7096C17.0833 16.9596 16.9992 17.1679 16.831 17.3346C16.6628 17.5013 16.4526 17.5846 16.2003 17.5846ZM5.06086 8.27374L6.54805 6.85066C6.57476 6.82928 6.59212 6.7999 6.60014 6.76251C6.60815 6.72511 6.60682 6.69039 6.59614 6.65834L6.23395 4.79616C6.22327 4.75342 6.20457 4.72137 6.17787 4.70001C6.15116 4.67864 6.11643 4.66795 6.0737 4.66795H4.29164C4.25959 4.66795 4.23289 4.67864 4.21151 4.70001C4.19014 4.72137 4.17945 4.74808 4.17945 4.78014C4.22218 5.34958 4.3154 5.92811 4.45909 6.51572C4.6028 7.10333 4.80339 7.68934 5.06086 8.27374ZM12.3108 15.4756C12.8632 15.7331 13.4393 15.93 14.0392 16.0662C14.6391 16.2024 15.1998 16.2833 15.7211 16.309C15.7532 16.309 15.7799 16.2983 15.8012 16.2769C15.8226 16.2556 15.8333 16.2288 15.8333 16.1968V14.4436C15.8333 14.4009 15.8226 14.3661 15.8012 14.3394C15.7799 14.3127 15.7478 14.294 15.7051 14.2833L13.9551 13.9276C13.9231 13.9169 13.895 13.9155 13.871 13.9236C13.8469 13.9316 13.8216 13.9489 13.7948 13.9756L12.3108 15.4756Z"
            fill="#667085" />
        </g>
      </svg>

      <a class="tel-link" href="tel:+380800337506">+38 080 033 7506</a>
    </div>

    <div class="network-check-offline-modal-footer-link">
      <svg
        class="mail-icon"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.3335 5.16675L6.77678 8.97704C7.21756 9.28559 7.43795 9.43986 7.67767 9.49962C7.88943 9.5524 8.1109 9.5524 8.32265 9.49962C8.56238 9.43986 8.78277 9.28559 9.22355 8.97704L14.6668 5.16675M4.5335 13.8334H11.4668C12.5869 13.8334 13.147 13.8334 13.5748 13.6154C13.9511 13.4237 14.2571 13.1177 14.4488 12.7414C14.6668 12.3136 14.6668 11.7535 14.6668 10.6334V6.36675C14.6668 5.24664 14.6668 4.68659 14.4488 4.25877C14.2571 3.88244 13.9511 3.57648 13.5748 3.38474C13.147 3.16675 12.5869 3.16675 11.4668 3.16675H4.5335C3.41339 3.16675 2.85334 3.16675 2.42552 3.38474C2.04919 3.57648 1.74323 3.88244 1.55148 4.25877C1.3335 4.68659 1.3335 5.24664 1.3335 6.36675V10.6334C1.3335 11.7535 1.3335 12.3136 1.55148 12.7414C1.74323 13.1177 2.04919 13.4237 2.42552 13.6154C2.85334 13.8334 3.41339 13.8334 4.5335 13.8334Z"
          stroke="#667085"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      <a class="mail-link" href="mailto:support@neolink.co ">{{
        'support@neolink.co '
      }}</a>
    </div>
    <p>{{ 'REGARDS_TEAM' | translate }} <strong>Neolink</strong>.</p>
    <button mat-button mat-dialog-close>{{ 'CONFIRM' | translate }}</button>
  </div>
</div>
